/**
 * @generated SignedSource<<9408833c8aba857c2b9cf00d18e50512>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingRecordingPromptFeedbackSource = "ACTION_ITEMS" | "CHAPTERS" | "DECISIONS" | "SUMMARY";
export type DislikeModalFeedbackSummaryMutation$variables = {
  feedback?: ReadonlyArray<string> | null;
  meetingRecordingSummaryId: string;
  otherFeedback?: string | null;
  source: MeetingRecordingPromptFeedbackSource;
};
export type DislikeModalFeedbackSummaryMutation$data = {
  readonly summaryFeedback: {
    readonly meetingRecordingSummary: {
      readonly feedback: {
        readonly dontLikeTheTone: boolean;
        readonly id: string;
        readonly missingInformation: boolean;
        readonly notFactuallyCorrect: boolean;
        readonly other: boolean;
        readonly otherFeedback: string | null;
      } | null;
      readonly id: string;
    };
  } | null;
};
export type DislikeModalFeedbackSummaryMutation = {
  response: DislikeModalFeedbackSummaryMutation$data;
  variables: DislikeModalFeedbackSummaryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "feedback"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingSummaryId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherFeedback"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "source"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "feedback",
        "variableName": "feedback"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingSummaryId",
        "variableName": "meetingRecordingSummaryId"
      },
      {
        "kind": "Variable",
        "name": "otherFeedback",
        "variableName": "otherFeedback"
      },
      {
        "kind": "Variable",
        "name": "source",
        "variableName": "source"
      }
    ],
    "concreteType": "SummaryFeedback",
    "kind": "LinkedField",
    "name": "summaryFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecordingSummary",
        "kind": "LinkedField",
        "name": "meetingRecordingSummary",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecordingPromptFeedback",
            "kind": "LinkedField",
            "name": "feedback",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "missingInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notFactuallyCorrect",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontLikeTheTone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "other",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherFeedback",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DislikeModalFeedbackSummaryMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "DislikeModalFeedbackSummaryMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "d8783d0523ba551a4d8365432204d2cc",
    "id": null,
    "metadata": {},
    "name": "DislikeModalFeedbackSummaryMutation",
    "operationKind": "mutation",
    "text": "mutation DislikeModalFeedbackSummaryMutation(\n  $meetingRecordingSummaryId: ID!\n  $feedback: [String!]\n  $otherFeedback: String\n  $source: MeetingRecordingPromptFeedbackSource!\n) {\n  summaryFeedback(meetingRecordingSummaryId: $meetingRecordingSummaryId, feedback: $feedback, otherFeedback: $otherFeedback, source: $source) {\n    meetingRecordingSummary {\n      id\n      feedback {\n        id\n        missingInformation\n        notFactuallyCorrect\n        dontLikeTheTone\n        other\n        otherFeedback\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "32c91826bd6df78bd783b8e6ca0eb334";

export default node;
